import { InactiveMemberEntity } from "@/modules/boxDashboard/modules/InactiveMembers/entities/inactiveMemberEntity"
import { useServicesContext } from "@modules/core/services/services.context"
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query"

export const INACTIVE_MEMBERS_QUERY_KEY = ["inactiveMembers"]
export const INACTIVE_MEMBERS_PAGE_SIZE = 10

export function useInactiveMembers(page = 0, pageSize = INACTIVE_MEMBERS_PAGE_SIZE) {
  const { boxDashboardApi } = useServicesContext()

  const { data, isLoading, isFetching, error, refetch } = useQuery({
    queryKey: [...INACTIVE_MEMBERS_QUERY_KEY, page, pageSize],
    queryFn: async () => {
      const dto = await boxDashboardApi.getInactiveMembers(page, pageSize)
      return {
        members: dto.content.map((member) => InactiveMemberEntity.fromDto(member)),
        totalCount: dto.totalElements,
        totalPages: dto.totalPages,
        currentPage: dto.page,
      }
    },
    staleTime: 0,
    gcTime: 0,
  })

  return {
    members: data?.members ?? [],
    totalCount: data?.totalCount ?? 0,
    totalPages: data?.totalPages ?? 0,
    currentPage: data?.currentPage ?? 0,
    hasMore: data ? data.currentPage < data.totalPages - 1 : false,
    isLoading,
    isFetching,
    error,
    refetch,
  }
}

export function useArchiveInactiveMember() {
  const { boxDashboardApi } = useServicesContext()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (id: string) => {
      await boxDashboardApi.archiveInactiveMember(id)
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: INACTIVE_MEMBERS_QUERY_KEY })
    },
  })
}
